// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SpinningIcon_spinner__1ej0R","spin":"SpinningIcon_spin__39Rt7"};